import React from "react";

const RefreshAltIcon = ({className = "", ...rest}) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="20"
			height="20"
			viewBox="0 0 20 20"
			fill="none"
			className={className}
			{...rest}
		>
			<mask
				id="mask0_1723_93709"
				style={{maskType: "alpha"}}
				maskUnits="userSpaceOnUse"
				x="0"
				y="0"
				width="20"
				height="20"
			>
				<rect width="20" height="20" fill="#D9D9D9" />
			</mask>
			<g mask="url(#mask0_1723_93709)">
				<path
					d="M10 16C8.33333 16 6.91667 15.4167 5.75 14.25C4.58333 13.0833 4 11.6667 4 10C4 8.33333 4.58333 6.91667 5.75 5.75C6.91667 4.58333 8.33333 4 10 4C10.9028 4 11.7396 4.1875 12.5104 4.5625C13.2812 4.9375 13.9444 5.4375 14.5 6.0625V4H16V9H11V7.5H13.7292C13.3264 6.88889 12.7986 6.40278 12.1458 6.04167C11.4931 5.68056 10.7778 5.5 10 5.5C8.75 5.5 7.6875 5.9375 6.8125 6.8125C5.9375 7.6875 5.5 8.75 5.5 10C5.5 11.25 5.9375 12.3125 6.8125 13.1875C7.6875 14.0625 8.75 14.5 10 14.5C11.1667 14.5 12.1667 14.1146 13 13.3438C13.8333 12.5729 14.3125 11.625 14.4375 10.5H15.9792C15.8542 12.0556 15.2222 13.3611 14.0833 14.4167C12.9444 15.4722 11.5833 16 10 16Z"
					fill="#4E5555"
				/>
			</g>
		</svg>
	);
};

export default RefreshAltIcon;
